import { Entity } from '@adornis/baseql/decorators.js';
import { FormOfFinancing } from './FormOfFinancing.js';

/**
 * @entity FormOfFinancingBuT
 */
@Entity()
export class FormOfFinancingBuT extends FormOfFinancing {
  public static override _class = 'FormOfFinancingBuT';
}
